import Code from 'models/Code';
import { observable } from 'mobx';
import { serialize, deserialize } from 'serializers/TnvedCode';

export default class TnvedCode extends Code {

  @observable additionalDues
  @observable advice
  @observable budgetClassification
  @observable certification
  @observable classificationCertificate
  @observable preliminaryClassificationCertificate
  @observable featuresOfCustomsClearance
  @observable code
  @observable comments
  @observable notes
  @observable classification_comments
  @observable customsLaboratoris
  @observable description
  @observable dualUseGoods
  @observable duty
  @observable free_trade_zone_agreements
  @observable duty_sng
  @observable exciseDues
  @observable exciseDutyMarks
  @observable exportDues
  @observable exportDuesAdjust
  @observable fillingInstruction
  @observable licence
  @observable ondate
  @observable quota
  @observable shortDescription
  @observable tariffPreference
  @observable unitName
  @observable vat
  @observable to_date
  @observable id
  @observable parent
  @observable tnved
  @observable code14
  @observable direction
  @observable intellectual
  @observable parallel_import

  parse(json) {
    return deserialize(json);
  }

  toJSON() {
    return serialize(this);
  }

}



// WEBPACK FOOTER //
// ./src/models/TnvedCode.js